import { Collapse } from "antd";
import OrderTable from "components/orders/OrderTable";
import CollapsePanelHeader from "components/reusable/CollapsePanelHeader";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ELIAS_ORDER_EMAIL_ADDRESS } from "utils/global/constants";
import { formatDateYYYYMMDD } from "utils/global/helper";

const FILTER_SETTINGS = {
  applyForPermit: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    requestApproval: false,
    permitGranted: false,
    closeOrder: false,
  },
  permitsNotGranted: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    requestApproval: true,
    permitGranted: false,
    closeOrder: false,
  },
  erectSigns: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    erectSigns: false,
    collectSigns: false,
    closeOrder: false,
  },
  drawUpInstallationProtocol: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    erectSigns: true,
    installationProtocol: false,
    sendDocumentsToCustomer: false,
    collectSigns: false,
    closeOrder: false,
  },
  sendDocumentsToCustomer: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    installationProtocol: true,
    sendDocumentsToCustomer: false,
    collectSigns: false,
    closeOrder: false,
  },
  collectSigns: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    erectSigns: true,
    collectSigns: false,
    closeOrder: false,
  },
  sendInvoice: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    sendInvoice: false,
    closeOrder: false,
  },
  invoiceOpen: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    sendInvoice: true,
    invoicePaid: false,
    closeOrder: false,
  },
  invoicePaid: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    invoicePaid: true,
    closeOrder: false,
  },
  // No status filter: important orders should show regardless of status
  wichtig: {},

  //schilder Aufstellen and Abholen
  erectSignsAndCollectSigns: {
    acceptOrder: true,
    rejectOrder: false,
    failedOrder: false,
    collectSigns: false,
    closeOrder: false,
  },
};

const today = new Date();
const threeDaysAgo = new Date(today);
threeDaysAgo.setDate(today.getDate() - 3);
const threeDaysLater = new Date(today);
threeDaysLater.setDate(today.getDate() + 3);

const defaultDateStart = formatDateYYYYMMDD(threeDaysAgo);
const defaultDateEnd = formatDateYYYYMMDD(threeDaysLater);

const Index = () => {
  const { t } = useTranslation();

  const [totalNumbers, setTotalNumbers] = useState({});

  // Callback function to update totalNumbers state
  const handleTotalDataChange = (key, count) => {
    setTotalNumbers((prevTotalNumbers) => ({
      ...prevTotalNumbers,
      [key]: count,
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        {Object.entries(FILTER_SETTINGS).map(([key, filterSettings]) => (
          <div
            key={key}
            style={{
              marginTop: key === "erectSignsAndCollectSigns" ? 40 : 0,
            }}
          >
            <Collapse key={key}>
              <Collapse.Panel
                header={
                  <CollapsePanelHeader
                    textKey={t(`task:tableHeadings.${key}`)}
                    totalNumber={totalNumbers[key]}
                  />
                }
                forceRender
                key={key}
              >
                <OrderTable
                  {...(key === "erectSigns" && { orderBy: "setupDate" })}
                  {...(key === "collectSigns" && { orderBy: "pickupDate" })}
                  {...((key === "sendInvoice" || key === "invoiceOpen") && {
                    excludeEmail: ELIAS_ORDER_EMAIL_ADDRESS,
                  })}
                  {...((key === "applyForPermit" ||
                    key === "permitsNotGranted") && {
                    withPermission: true,
                  })}
                  {...((key === "erectSignsAndCollectSigns" ||
                    key === "erectSigns" ||
                    key === "collectSigns") && {
                    // In setup and pickup tasks table, hide order with `noSignInstallation` true
                    noSignInstallation: false,
                  })}
                  {...(key === "wichtig" && {
                    isImportant: true,
                  })}
                  {...(key === "erectSignsAndCollectSigns" && {
                    combinedSignMode: true,
                    showPdfExport: true,
                    pdfTitle: "Schilder aufstellen & Schilder abholen",
                    orderBy: "zipCode",
                    pageSize: 100,
                    defaultSetupDateStart: defaultDateStart,
                    defaultSetupDateEnd: defaultDateEnd,
                    defaultPickupDateStart: defaultDateStart,
                    defaultPickupDateEnd: defaultDateEnd,
                  })}
                  statusFilter={filterSettings}
                  onTotalDataChange={(count) =>
                    handleTotalDataChange(key, count)
                  }
                  hasAll={key !== "erectSignsAndCollectSigns"}
                />
              </Collapse.Panel>
            </Collapse>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Index;
